// extracted by mini-css-extract-plugin
export default {"card":"w0-z","carouselContainer":"x0-z","carouselContent":"y0-z"};